import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=b961b1d4&scoped=true&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"
import style0 from "./login-form.vue?vue&type=style&index=0&id=b961b1d4&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b961b1d4",
  null
  
)

export default component.exports